import React from "react";
import set from "@rill/set";

import NewsView from "./news";
import NewsModal from "./components/NewsModal";
import FilterNewsModal from "../../parts/modals/filter-news";

const newsController = (app) => {
  app
    .use(set("heading", ["Admin", "Announcements"]))
    .get("/news", async ({ load, locals, res, req }) => {
      const { query = {} } = req;
      const { modal = {} } = query;

      locals.query = query;


      const pageSize = 12;
      const page = parseInt(query.page, 10) || 1;
      await load("adminNews", {
        skip: (page - 1) * pageSize,
        limit: pageSize,
        filterFrom: query.filterFrom,
        filterTo: query.filterTo,
        filterPublished: `${query.filterPublished}`,
      });

      locals.modal = {
        "new-news": <NewsModal locals={locals} />,
        "edit-news": <NewsModal locals={locals} newsId={query.newsId} />,
        "filter-news": (
          <FilterNewsModal
            filterFrom={query.filterFrom}
            filterTo={query.filterTo}
            filterPublished={query.filterPublished}
          />
        ),
      }[modal.type];

      res.body = <NewsView />;
    });
};

export default newsController;
